import { Injectable } from '@angular/core';

@Injectable()
export class IeTestService {

  constructor() { }

  isIE() {
    var myNav = navigator.userAgent.toLowerCase();
    return (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
  }

  checkIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    if (msie > 0) // If Internet Explorer, return version number
    {
      if (parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)))) {
        return true
      } else {
        return false;
      }
    }
    else // If another browser, return 0
    {
      //console.log('otherbrowser');
      return false
    }
  }

  msieversion() {

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
    {
      console.log(parseInt(ua.substring(msie + 5, ua.indexOf(".", msie))));
      return true;
    }
    else  // If another browser, return 0
    {
      return false;
    }
  }

}
